import { render, staticRenderFns } from "./services.vue?vue&type=template&id=d271e272&scoped=true&"
import script from "./services.vue?vue&type=script&lang=js&"
export * from "./services.vue?vue&type=script&lang=js&"
import style0 from "./services.vue?vue&type=style&index=0&id=d271e272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d271e272",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectForm: require('/builds/knockmedia/knock-vi-web/src/components/ProjectForm.vue').default})
